import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import './assets/fonts/styles/base.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faCreditCard,
  faMoneyBill1,
  faHandshake,
  faNoteSticky
} from '@fortawesome/free-regular-svg-icons'

import {
  faGift,
  faBoxOpen,
  faXmark,
  faTicket,
  faMoneyBillWave,
  faArrowTrendDown,
  faUserPlus,
  faUserPen,
  faStore,
  faKey,
  faRightFromBracket,
  faListCheck,
  faTrashCan
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faCreditCard,
  faMoneyBill1,
  faHandshake,
  faNoteSticky,
  faGift,
  faBoxOpen,
  faXmark,
  faTicket,
  faMoneyBillWave,
  faArrowTrendDown,
  faUserPlus,
  faUserPen,
  faStore,
  faKey,
  faRightFromBracket,
  faListCheck,
  faTrashCan
)

const app = createApp(App)

app.component('font-awesome-icon', FontAwesomeIcon)

app.use(store).use(router).mount('#app')
